<div mat-dialog-content>
    {{message}}
   </div>
   <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button> 
    <button mat-button (click)="onNoClick()">No</button>     
</div>   